import {Component, Input} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";

@Component({
    selector: 'app-confirm',
    templateUrl: './confirm.component.html',
    styleUrls: ['./confirm.component.scss'],
    standalone: false
})
export class ConfirmComponent {

  @Input() public title: string = 'Bitte bestätigen Sie';
  @Input() public text: SafeHtml = '';
  @Input() public yesbuttontext: string = 'Ja';
  @Input() public nobuttontext: string = 'Nein';
  @Input() public onYes = (): Function => {
    return null;
  };
  @Input() public onNo = (): Function => {
    return null;
  };

  constructor(
    public translate: TranslateService,
    private readonly modalService: NgbActiveModal,
    private readonly sanitizer: DomSanitizer
  ) { }

  accept(){
    this.onYes();
    this.modalService.close()
  }

  reject(){
    this.onNo();
    this.modalService.close()
  }

  setTitle(title: string){
    this.title = title;
  }

  setText(text: string){
    this.text = this.sanitizer.bypassSecurityTrustHtml(text);
  }

}
